import { useTranslation } from '@infra/i18n';
import { cn } from '@shared/lib';

export interface PageSizeSelectProps {
  value: number;
  options: readonly number[];
  onChange: (size: number) => void;
  disabled?: boolean;
  className?: string;
}

export function PageSizeSelect(props: PageSizeSelectProps) {
  const { value, options, onChange, className, disabled } = props;
  const { t } = useTranslation();
  return (
    <label
      className={cn(
        'inline-flex items-center gap-2 text-xs font-semibold text-muted-foreground',
        className
      )}
    >
      {t('common:rowsPerPage')}
      <select
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(Number(e.target.value))}
        className="h-8 rounded-lg border border-input bg-background px-2 text-xs font-semibold text-foreground"
      >
        {options.map((size) => (
          <option key={size} value={size}>
            {size}
          </option>
        ))}
      </select>
    </label>
  );
}
